module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    attrs: {
      "id": "activate"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('section', {
    staticClass: "hero is-fullheight is-medium"
  }, [_c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "section has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "Piscicultura Global"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), (_vm.status) ? _c('h2', {
    staticClass: "subtitle"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Iniciar Sesión")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "is-info",
    attrs: {
      "href": _vm.social.twitter
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.social.facebook
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-facebook-official"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.social.linkedin
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-linkedin"
  })])])])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_vm._v("\n          ©"), _c('a', {
    attrs: {
      "href": "http://pisciculturaglobal.com/"
    }
  }, [_vm._v("Piscicultura Global")]), _vm._v(" "), _c('br'), _vm._v("\n          Todos los derechos reservados 2017\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc66c24","hasScoped":true}!./src/pages/verify/template.html
// module id = 413
// module chunks = 1